export default "__VITE_ASSET__CWN97bSp__"